export default __webpack_public_path__ + "static/media/basic.1435fce5.svg";